export default __webpack_public_path__ + "static/media/plus-circle-outline.42e5a51f.svg";